<template>
  <div class="relative">
    <div class="absolute top-14 right-5 z-50">
      <a @click="logOut">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.90002 7.56023C9.21002 3.96023 11.06 2.49023 15.11 2.49023H15.24C19.71 2.49023 21.5 4.28023 21.5 8.75023V15.2702C21.5 19.7402 19.71 21.5302 15.24 21.5302H15.11C11.09 21.5302 9.24002 20.0802 8.91002 16.5402" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15 12H3.62" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.85 8.6499L2.5 11.9999L5.85 15.3499" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>

    </div>
    <div class="h-screen overflow-hidden">
      <div class="relative">
        <svg class="w-full" width="359" height="194" viewBox="0 0 359 194" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <path d="M262.427 -116.44C301.116 -151.543 360.936 -148.636 396.039 -109.948L463.746 -35.3256C498.849 3.36329 495.943 63.1838 457.254 98.2872L377.187 170.934C331.968 211.962 259.698 195.282 237.033 138.587L236.118 136.298C228.651 117.619 214.513 102.378 196.447 93.5313V93.5313C144.935 68.3062 135.125 -0.936084 177.603 -39.477L262.427 -116.44Z" fill="url(#paint0_linear_0_1)"/>
          <path d="M267.024 -104.899C306.567 -139.037 366.298 -134.655 400.436 -95.1119L441.431 -47.6259C475.569 -8.08263 471.187 51.6479 431.644 85.786L373.517 135.968C336.798 167.667 279.54 148.748 268.935 101.413V101.413C264.288 80.6731 249.47 63.4962 229.707 55.6767V55.6767C183.623 37.4431 172.692 -23.4617 210.207 -55.848L267.024 -104.899Z" fill="url(#paint1_linear_0_1)"/>
          <rect y="56" width="48" height="48" fill="url(#pattern0)"/>
          <defs>
            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlink:href="#image0_0_1" transform="scale(0.0166667)"/>
            </pattern>
            <linearGradient id="paint0_linear_0_1" x1="332.479" y1="-180" x2="341.038" y2="187.993" gradientUnits="userSpaceOnUse">
              <stop stop-color="#E60000"/>
              <stop offset="1" stop-color="#E60000" stop-opacity="0.43"/>
            </linearGradient>
            <linearGradient id="paint1_linear_0_1" x1="338.624" y1="-166.711" x2="334.248" y2="149.614" gradientUnits="userSpaceOnUse">
              <stop stop-color="#E60000"/>
              <stop offset="1" stop-color="#E60000" stop-opacity="0.43"/>
            </linearGradient>
            <image id="image0_0_1" width="60" height="60" xlink:href="data:image/png;base64,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"/>
          </defs>
        </svg>


        <h1 class="absolute left-5 top-36 text-2xl font-montserrat-bold">Hola</h1>
      </div>
      <div class="mt-6 mx-5">
        <span class="fecha text-xs">Fecha</span>
<!--        <v-select-->
<!--            :items="dateLists"-->
<!--            label="Solo field"-->
<!--            dense-->
<!--            solo-->
<!--            flat-->
<!--        ></v-select>-->
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                label="Picker in menu"
                dense
                solo
                flat
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="date"
              no-title
              scrollable
              color="#F81600"
              event-color="#F81600"
              @change="addFilter"
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="error"
                @click="menu = false"
            >
              Cancel
            </v-btn>
            <v-btn
                text
                color="error"
                @click="$refs.menu.save(date)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </div>
      <div class="mt-2 mx-5 h-72 overflow-y-auto">
        <div v-if="loading" class="h-72 w-full items-center flex justify-center">
          <v-progress-circular
              :width="4"
              color="red"
              indeterminate
          ></v-progress-circular>
        </div>
        <div v-if="!loading">
          <div v-for="(item,index) in items" :key="index">
            <a @click="showDetails(item._id)">
              <div class="flex justify-between">
                <div class="w-9 h-9">
                  <img class="w-9 h-9" src="../assets/img/placeholder.jpg" alt="">
                </div>
                <div class="w-full ml-4">
                  <h2 class="text-black font-montserrat-regular">{{ item.model }} - {{ item.work_order }}</h2>
                  <span v-if="item.operation_ok === true" class="uppercase text-theme-4">OK</span>
                  <span v-if="item.operation_ok === false" class="uppercase text-theme-1">KO</span>
                </div>
                <v-icon
                    right
                    dark
                    color="#000000"
                >
                  mdi-chevron-right
                </v-icon>
              </div>
              <v-divider class="mt-2 mb-2"></v-divider>
            </a>
          </div>
        </div>
      </div>
      <div class="fixed w-full bottom-0 px-5 pb-5">
        <v-btn @click="goToCameraComponent" block color="#4A4D4E" class="orden white--text font-montserrat-light capitalize justify-between" x-large>
          Nuevo Orden
          <v-icon
              right
              dark
          >
            mdi-arrow-right
          </v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
// import redirect from "@/mixins/redirect";
import {mapGetters} from "vuex"

export default {
  name: "Orders",
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      loading: false,
    }
  },
  beforeMount() {
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();
    today = yyyy + '-' + mm + '-' + dd;
    this.loading = true
    // this.$store.dispatch("loginUser/userDataAction", this.$session.get("username"))
    this.$store.dispatch("loginUser/userJobsByDate", {userId: this.$session.get("username"), payload: today})
    this.loading = false
  },
  mounted() {
    if (this.$session.get("username")) {
      return true
    } else {
      this.$router.push("/")
    }
  },
  computed: {
    ...mapGetters({
      items: "loginUser/userDataGetters"
    })
  },
  methods: {
    showDetails(id) {
      return this.$router.push(`/details/${id}`).catch(()=>{})
    },
    goToCameraComponent() {
      return this.$router.push("/add-new")
    },
    logOut() {
      this.$session.remove("username")
      return this.$router.push("/")
    },
    addFilter() {
      this.loading = true
      this.$store.dispatch("loginUser/userJobsByDate", {userId: this.$session.get("username"), payload: this.date})
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.orden {
    border-radius: 12px !important;
    ::v-deep & .v-btn__content {
      justify-content: space-between;
    }
}
.fecha {
  color: #5E5873;
}
.v-input {
    ::v-deep .v-input__slot {
      border: 1px solid #D8D6DE !important;
  }
}
::v-deep .v-text-field__slot {
  font-size: 12px !important;
  input {
    color: #B9B9C3 !important;
  }
}
</style>
